const INACTIVE_AFTER_HOURS = 6;

export function isInactiveSensor(record) {
    const eventDateTime = record?.properties?.eventDateTime ?? record?.eventDateTime;
    if (!eventDateTime) {
        return false;
    }

    const eventTime = new Date(eventDateTime).getTime();
    if (Number.isNaN(eventTime)) {
        return false;
    }

    const hoursSilent = Math.floor((Date.now() - eventTime) / (60 * 60 * 1000));
    return hoursSilent >= INACTIVE_AFTER_HOURS;
}
